/**
 * Pinia plugin that adds a `resetAll()` method to the Pinia instance that will
 * call the `$reset()` method on all registered stores. Note that `$reset()` is only
 * available on stores defined with the Options API or setup stores that explicitly
 * implement a reset function.
 * @returns {Function} A Pinia plugin function that can be used with pinia.use()
 *
 * @example
 * // Setup in main.js
 * import { createPinia } from 'pinia'
 * import { createResetAllPlugin } from '@/stores/plugins/global-reset';
 *
 * const pinia = createPinia()
 * pinia.use(createResetAllPlugin())
 *
 * @example
 * // Usage with companion composable
 * import { useResetAllStores } from '@/composables/useResetAllStores';
 * const resetAll = useResetAllStores()
 * resetAll()
 */
export function createResetAllPlugin() {
  return ({ pinia }) => {
    pinia.resetAll = function () {
      // Access all stores from Pinia's internal state
      pinia._s?.forEach((store) => {
        if (typeof store.$reset === 'function') {
          store.$reset();
        }
      });
    };
  };
}
